import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";

const ErrorPage = ({ errorMessage, refetch }) => {
  return (
    <Box
      sx={{
        backgroundImage: "linear-gradient(to right, #0B0F19, #1A2E55)",
        color: "#FFFFFF",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        paddingY: "60px",
      }}
    >
      <Container maxWidth="md" sx={{ textAlign: "center" }}>
        <Typography
          variant="h2"
          sx={{
            fontWeight: 800,
            fontSize: { xs: "2.5rem", md: "3.5rem" },
            marginBottom: "24px",
            color: "#FFFFFF",
            textShadow: "2px 2px 8px rgba(0, 0, 0, 0.3)",
          }}
        >
          Oops! Something went wrong.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: "#D1D5DB",
            maxWidth: "600px",
            margin: "0 auto 40px auto",
            fontSize: { xs: "1rem", md: "1.2rem" },
            lineHeight: 1.75,
          }}
        >
          {errorMessage ||
            "We encountered an error while trying to process your request. Please try again later or contact support."}
        </Typography>

        <Button
          variant="contained"
          sx={{
            backgroundColor: "#10a7e0",
            color: "#FFFFFF",
            textTransform: "uppercase",
            padding: "12px 28px",
            fontSize: "1rem",
            borderRadius: "50px",
            boxShadow: "0 6px 20px rgba(0, 123, 255, 0.3)",
            transition: "transform 0.3s ease, box-shadow 0.3s ease",
            "&:hover": {
              backgroundColor: "#10a7e0",
              transform: "scale(1.05)",
              boxShadow: "0 8px 24px rgba(0, 86, 179, 0.4)",
            },
          }}
          onClick={refetch}
        >
          Try Again
        </Button>
      </Container>
    </Box>
  );
};

export default ErrorPage;
